<div class="nav" *ngIf="store">
  <div class="app-nav-links">
    <mat-nav-list [class.nav-list--ordered]="customNavOrder">
      <a class="ml-1" mat-list-item [routerLink]="['/home/info']" [style.order]="navOrderIndex('home')" routerLinkActive="is-active"
        *ngIf="permission?.hasPermission('ACCESS', 'HOME')" (click)="onOrdersClick('/home/info')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">store_mall_directory</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Home</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/orders']" [style.order]="navOrderIndex('orders')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('DIGITAL_ORDERING') && permission?.hasPermission('ACCESS', 'ORDERS')"
        (click)="onOrdersClick('/home/orders')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">shopping_bag</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Orders</span>
      </a>
      <!-- Delivery dispatch (ENG-5514): opens the dedicated full-screen tool -->
      <a class="ml-1" mat-list-item [routerLink]="['/dispatch']" [style.order]="navOrderIndex('dispatch')"
        *ngIf="store?.has_order_occasion_delivery && store?.feature_flag?.['delivery_v2'] && permission?.hasPermission('ACCESS', 'ORDERS')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">delivery_dining</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Dispatch</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/reporting']" [style.order]="navOrderIndex('reporting')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('REPORTING_MODULE') && permission?.hasPermission('ACCESS', 'REPORTING_TAB')"
        (click)="onOrdersClick('/home/reporting')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">receipt</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Reporting</span>
      </a>
      <!-- <a class="ml-1" mat-list-item [routerLink]="['/home/insights']" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('INSIGHTS_MODULE') && permission?.hasPermission('ACCESS', 'INSIGHTS')"
        (click)="onOrdersClick('/home/insights')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">assessment</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Insights</span>
      </a> -->
      <a class="ml-1" mat-list-item [routerLink]="['/home/menu']" [style.order]="navOrderIndex('menu')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('MENU_MODULE') && permission?.hasPermission('ACCESS', 'MENU')"
        (click)="onOrdersClick('/home/menu')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">local_dining</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Menu</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/menu-photos']" [style.order]="navOrderIndex('menu_photos')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('MENU_MODULE') && permission?.hasPermission('ACCESS', 'MENU')"
        (click)="onOrdersClick('/home/menu-photos')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">photo_camera</mat-icon>
        <span class="ml-1 item-name text-sm" [ngClass]='(menuPhotoStats | async)?.missing?.length > 0 ? "bold" : ""'
          *ngIf="opened">Menu Photos</span>
        <span class="unread" *ngIf='(menuPhotoStats | async)?.missing?.length > 0 && opened'>{{(menuPhotoStats | async)?.missing?.length}}</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/voice-ordering']" [style.order]="navOrderIndex('voice_ordering')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('VOICE_ORDERING') && permission?.hasPermission('ACCESS', 'VOICE_ORDERING')"
        (click)="onOrdersClick('/home/voice-ordering')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">record_voice_over</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Voice Ordering</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/invoice']" [style.order]="navOrderIndex('invoices')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('INVOICE_MODULE') && permission?.hasPermission('ACCESS', 'INVOICING_TAB')"
        (click)="onOrdersClick('/home/invoice')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">receipt_long</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Invoices</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/messages']" [style.order]="navOrderIndex('messages')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('BUSINESS_MESSAGING') && permission?.hasPermission('ACCESS', 'MESSAGES')"
        (click)="onOrdersClick('/home/messages')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">forum</mat-icon>
        <span class="ml-1 item-name text-sm" [ngClass]='unreadCounter?.total > 0 ? "bold" : ""'
          *ngIf="opened">Messages</span>
        <span class="unread" *ngIf='unreadCounter?.total > 0 && opened'>{{unreadCounter?.total}}</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/offers']" [style.order]="navOrderIndex('gift_cards')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('DIGITAL_GIFT_CARDS') && permission?.hasPermission('ACCESS', 'GIFT_CARDS')"
        (click)="onOrdersClick('/home/offers')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">card_giftcard</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Gift Cards</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/offers-v2']" [style.order]="navOrderIndex('offers')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('OFFERS') && permission?.hasPermission('ACCESS', 'OFFERS')"
        (click)="onOrdersClick('/home/offers-v2')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">local_offer</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Offers</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/campaign']" [style.order]="navOrderIndex('campaign')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('SMS_MARKETING') && permission?.hasPermission('ACCESS', 'CAMPAIGNS')"
        (click)="onOrdersClick('/home/campaign')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">announcement</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Campaign</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/attendant']" [style.order]="navOrderIndex('attendant')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('ATTENDANT') && permission?.hasPermission('ACCESS', 'ATTENDANT')"
        (click)="onOrdersClick('/home/attendant')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">phone_in_talk</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Attendant</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/digital-display']" [style.order]="navOrderIndex('digital_display')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('DIGITAL_DISPLAY_MODULE') && permission?.hasPermission('ACCESS', 'DIGITAL_DISPLAY')"
        (click)="onOrdersClick('/home/digital-display')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">airplay</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Digital Display</span>
      </a>
      <!-- Devices (fleet management): Labrador support only (backend superuser), behind the device_fleet store flag while it rolls out -->
      <a class="ml-1" mat-list-item [routerLink]="['/home/devices']" [style.order]="navOrderIndex('devices')" routerLinkActive="is-active"
        *ngIf="store?.getFeatureFlag('device_fleet') && (fleetAccess.staff$ | async)"
        (click)="onOrdersClick('/home/devices')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">devices</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Devices</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/loyalty']" [style.order]="navOrderIndex('loyalty')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('LOYALTY_MODULE') && permission?.hasPermission('ACCESS', 'LOYALTY')"
        (click)="onOrdersClick('/home/loyalty')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">sentiment_satisfied_alt</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Loyalty</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/referral']" [style.order]="navOrderIndex('referral')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('REFERRAL_MODULE') && permission?.hasPermission('ACCESS', 'REFERRAL')"
        (click)="onOrdersClick('/home/referral')">
        <span class="set-referral">
          <!-- <span><img class="img-width-set" src="../../../assets/referral_icon.png"></span> -->
          <span class="material-symbols-outlined app-nav-list-icon" style="color: #636363;">
            p2p
          </span>
          <span class="google-font ml-1 item-name name-referral-set ml-1 item-name text-sm">Referral</span>
        </span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/skill']" [style.order]="navOrderIndex('skills')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('SKILLS_MODULE') && permission?.hasPermission('ACCESS', 'SKILLS')"
        (click)="onOrdersClick('/home/skill')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">adb</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Skills</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/feedback']" [style.order]="navOrderIndex('feedback')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('FEEDBACK_MODULE') && permission?.hasPermission('ACCESS', 'FEEDBACK')"
        (click)="onOrdersClick('/home/feedback')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">feedback</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Feedback</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/floor-plan']" [style.order]="navOrderIndex('floor_plan')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('FLOOR_PLAN_MODULE') && permission?.hasPermission('ACCESS', 'FLOOR_PLAN')"
        (click)="onOrdersClick('/home/floor-plan')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">table_restaurant</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Floor Plan</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/reservations']" [style.order]="navOrderIndex('reservations')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('RESERVATIONS_MODULE') && permission?.hasPermission('ACCESS', 'RESERVATIONS')"
        (click)="onOrdersClick('/home/reservations')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">event_available</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Reservations</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/influencers']" [style.order]="navOrderIndex('influencers')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('INFLUENCER_MODULE') && permission?.hasPermission('ACCESS', 'INFLUENCERS')"
        (click)="onOrdersClick('/home/influencers')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">campaign</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Influencers</span>
      </a>
<a class="ml-1" mat-list-item [routerLink]="['/home/kiosk']" [style.order]="navOrderIndex('kiosk')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('KIOSK_MODULE') && permission?.hasPermission('ACCESS', 'KIOSK')"
        (click)="onOrdersClick('/home/kiosk')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">tablet_android</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Kiosk</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/kitchenhub']" [style.order]="navOrderIndex('third_party')" routerLinkActive="is-active"
        *ngIf="store?.modules?.includes('KITCHENHUB_MODULE') && permission?.hasPermission('ACCESS', 'KITCHENHUB')"
        (click)="onOrdersClick('/home/kitchenhub')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">storefront</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Third Party</span>
      </a>
      <a class="ml-1" mat-list-item [routerLink]="['/home/google-business']" [style.order]="navOrderIndex('google_business')" routerLinkActive="is-active"
        *ngIf="store?.getFeatureFlag('google_business_profile')"
        (click)="onOrdersClick('/home/google-business')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">business</mat-icon>
        <span class="ml-1 item-name text-sm" *ngIf="opened">Google Business</span>
      </a>
      <!-- The support links, rendered in one of the two places above. Declared INSIDE this list so
                 their embedded views take its injector: MatListItem needs the enclosing MatNavList
                 for its interactive state (ripple, hover, pointer cursor). -->
      <ng-template #supportLinks>
            <a class="ml-1" mat-list-item [routerLink]="['/home/account']" [style.order]="navOrderIndex('account')" routerLinkActive="is-active"
              *ngIf="store?.modules?.includes('ACCOUNT_MODULE') && permission?.hasPermission('ACCESS', 'ACCOUNT')"
              (click)="onOrdersClick('/home/account')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">settings</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">Account</span>
            </a>
            <a class="ml-1" mat-list-item [routerLink]="['/home/users']" [style.order]="navOrderIndex('manage_users')" routerLinkActive="is-active"
              *ngIf="store?.modules?.includes('MANAGE_USERS_MODULE') && permission?.hasPermission('ACCESS', 'MANAGE_USERS')"
              (click)="onOrdersClick('/home/users')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">person_add_alt_1</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">Manage Users</span>
            </a>
            <!-- Team Scheduling — managers (MANAGE_USERS implicitly grants scheduling access)
                 Beta gate: on production only show for the PRODUCTION DEMO store. -->
            <a class="ml-1" mat-list-item [routerLink]="['/home/team-member-scheduling']" [style.order]="navOrderIndex('team_scheduling')" routerLinkActive="is-active"
              *ngIf="schedulingAllowedForStore
                     && store?.modules?.includes('MANAGE_USERS_MODULE')
                     && permission?.hasPermission('ACCESS', 'MANAGE_USERS')"
              (click)="onOrdersClick('/home/team-member-scheduling')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">groups</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">Team Scheduling</span>
            </a>
            <!-- My Schedule — employees with SCHEDULING permission (no MANAGE_USERS)
                 Beta gate: on production only show for the PRODUCTION DEMO store. -->
            <a class="ml-1" mat-list-item [routerLink]="['/home/team-member-scheduling/my-schedule']" [style.order]="navOrderIndex('my_schedule')" routerLinkActive="is-active"
              *ngIf="schedulingAllowedForStore
                     && store?.modules?.includes('MANAGE_USERS_MODULE')
                     && permission?.hasPermission('ACCESS', 'SCHEDULING')
                     && !permission?.hasPermission('ACCESS', 'MANAGE_USERS')"
              (click)="onOrdersClick('/home/team-member-scheduling/my-schedule')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">calendar_today</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">My Schedule</span>
            </a>
            <a class="ml-1" mat-list-item [routerLink]="['/home/time-clock']" [style.order]="navOrderIndex('time_clock')" routerLinkActive="is-active"
              *ngIf="store?.modules?.includes('TIME_CLOCK_MODULE') && permission?.hasPermission('ACCESS', 'TIME_CLOCK')"
              (click)="onOrdersClick('/home/time-clock')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">alarm_on</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">Time Clock</span>
            </a>
            <a class="ml-1" mat-list-item [routerLink]="['/home/pos-settings']" [style.order]="navOrderIndex('pos_settings')" routerLinkActive="is-active"
              *ngIf="store?.modules?.includes('POS_SETTINGS_MODULE') && permission?.hasPermission('ACCESS', 'POS_SETTINGS')"
              (click)="onOrdersClick('/home/pos-settings')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">tune</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">POS Settings</span>
            </a>
            <a class="ml-1" mat-list-item [routerLink]="['/home/settlements']" [style.order]="navOrderIndex('settlements')" routerLinkActive="is-active"
              *ngIf="store?.modules?.includes('SETTLEMENTS_MODULE') && permission?.hasPermission('ACCESS', 'SETTLEMENTS')"
              (click)="onOrdersClick('/home/settlements')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">summarize</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">Settlements</span>
            </a>
            <!-- ENG-4916 (web port): the store settings that moved off the Home tab. Gated on the
                 same ACCESS/HOME permission as Home, since Configuration is Home's settings half. -->
            <a class="ml-1" mat-list-item [routerLink]="['/home/configuration']" [style.order]="navOrderIndex('configuration')" routerLinkActive="is-active"
              *ngIf="permission?.hasPermission('ACCESS', 'HOME')"
              (click)="onOrdersClick('/home/configuration')">
              <!-- Not `settings` (Account) or `tune` (POS Settings) — both are already in this rail. -->
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">settings_applications</mat-icon>
              <span class="google-font ml-1 item-name text-sm" *ngIf="opened">Configuration</span>
            </a>
            <a class="ml-1" mat-list-item [routerLink]="['/home/support']" [style.order]="navOrderIndex('support')" routerLinkActive="is-active"
              *ngIf="store?.modules?.includes('SUPPORT_MODULE') && permission?.hasPermission('ACCESS', 'SUPPORT')"
              (click)="onOrdersClick('/home/support')">
              <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">help</mat-icon><span
                class="google-font ml-1 item-name text-sm" *ngIf="opened">Support</span>
            </a>
      </ng-template>
      <ng-container *ngIf="customNavOrder" [ngTemplateOutlet]="supportLinks"></ng-container>
    </mat-nav-list>
  </div>
  <div class="app-support-links">
    <mat-nav-list [class.nav-list--ordered]="customNavOrder">
      <!-- ENG-5687: with no custom order the support links render here, under the app links,
           exactly as before. With one, they render inside the app list above instead, so the
           merchant's order can interleave them (the rail reads as one list either way). -->
      <ng-container *ngIf="!customNavOrder" [ngTemplateOutlet]="supportLinks"></ng-container>

      <a class="ml-1" mat-list-item (click)="updateAppVersion()" *ngIf="!opened" [style.order]="navOrderIndex('_refresh')">
        <mat-icon matListItemIcon class="material-icons-outlined app-nav-list-icon">refresh</mat-icon>
      </a>
    </mat-nav-list>
  </div>
  <div class="items-center justify-between p-4 text-gray-500 text-sm border-t border-gray-300" *ngIf="opened && isWeb">
    <div class="flex items-center">
      <mat-icon class="text-gray-400 align-middle">info</mat-icon>
      <span class="ml-2 align-middle">Current Version: {{ currentVersion }}</span>
    </div>
    <div class="flex items-center">
      <mat-icon class="text-gray-400 align-middle">info</mat-icon>
      <span class="ml-2 align-middle">Latest Version: {{ latestVersion }}</span>
    </div>
    <button
      class="bg-blue-600 text-white text-base font-medium py-2 px-6 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 w-full p-3.5 mt-2"
      (click)="updateAppVersion()">
      <span class="align-middle">Update version</span>
    </button>
  </div>
</div>
